import { documentTypes } from 'utils/helpers/dictionaries';

import { IDocument } from '../uploadDocuments.interfaces';

import { IResponseStatus } from './responses.interfaces';
import { IActivity, IStage } from './user.interfaces';

export interface INotificationPU {
  activeModal: boolean;
  message: string;
  messageInfo: string;
  styleModal: string;
  help: boolean;
  extend?: boolean;
}

export interface IResponse {
  data: null;
  message: string;
  errorCode: string;
}

export interface IResponseMeet {
  message: string;
  statusCode: number;
  data: IActivity[];
}

export interface Data {
  id: number;
  url: string;
  date_start: string;
  date_end: string;
  email_interviewer: string;
  activityXJobId: number;
}

export interface ICustomError extends IResponseStatus {
  data: {
    data: null;
    message: string;
  };
}

export interface IConfirmCodeBody {
  email: string;
  code: string;
}

export interface IRestorePassword {
  email: string;
}
export interface IResendCode {
  email: string;
}

export interface ISendFile {
  idStage?: number;
  idVacant?: number;
  email?: string;
  data: IDataToSend;
  idActivity?: string;
  activityName?: string;
}

export interface ISetOnboarding {
  email: string;
  dashboard: string;
  status: number;
}

export interface IDataToSend {
  files: object;
  url?: string;
}

export interface ISendImage {
  id?: number;
  email?: string;
  option?: string;
  message?: string;
  adjuntos: IFileData[];
}

export interface IFileData {
  nombre: string;
  base64: string;
}

export interface INewPasswordBody {
  email: string;
  newPassword: string;
  confirmedPassword: string;
}

export interface IResponseSchedule extends IResponseStatus {
  data: IAgenda[];
}

export interface IAgenda {
  dayOfWeek: string;
  day: string;
  month: string;
  year: number;
  dateMorning: DateAfternoonElement[];
  dateAfternoon: DateAfternoonElement[];
}

export interface DateAfternoonElement {
  start: string;
  end: string;
  isAvailable: boolean;
  startDateUnix: string;
  endDateUnix: string;
}

export interface IGetAgenda {
  idActivity: string;
}

export interface IConfirmSchedule {
  idActivity: string;
  email: string;
  startUnixDate: number;
}

export interface IResponseActivitiesByIdStage {
  message: string;
  statusCode: number;
  data: IActivity[];
}

export interface IActivitiesByIdStage {
  idStage: string | number;
  idVacant?: string | number;
  email: string;
}

export interface IResponseStages {
  message: string;
  statusCode: number;
  errorCode: string;
  data: DataResponseStages;
}

export interface IResponseMaintenance {
  message: string;
  statusCode?: number;
  errorCode?: string;
  data: DataResponseMaintenance;
  dato: DataResponseMaintenance;
}

export interface DataResponseMaintenance {
  name: string;
  description: string;
  value: string;
}

export interface DataResponseStages {
  fullName: string;
  urlVacant: string;
  vacant: string;
  idVacant: number;
  idStage: number;
  preStage: number;
  stages: IStage[];
  id?: number;
}

export interface Icon {
  id: number;
  urlIcon: string;
  identifier: Identifier;
}

export enum Identifier {
  Normal = 'normal',
  Selected = 'selected',
}

export interface IEmail {
  email: string;
  idActivity?: string;
}

export interface IStatus {
  idStage?: string;
  idVacant?: number;
  email?: string;
  status?: string;
  activityName?: string;
}

export interface InterviewInfo extends IResponseStatus {
  data: DataInterview;
}

export interface DataInterview {
  id: number;
  url_meet: string;
  activity_x_job_application_id: number;
  date_interviewer: string;
  range_hours: string;
  name_interviewer: string;
  email_interviewer: string;
}
export interface IProfile {
  firstName?: string;
  lastName?: string;
  email: string;
  phoneNumber?: string;
  city?: string;
  country?: string;
  state?: string;
  vacant?: string;
  sortName?: string;
  phoneCode?: string;
  flagUrl?: string;
  bloodType?: string;
  bornDate?: string;
  direction?: string;
  idType?: string;
  numberId?: string;
  rh?: string;
  educationLevel?: string;
  institution: string;
  title: string;
  jobtitle: string;
  company: string;
  job_start_date: string;
  job_end_date: string;
  currentSalaryCurrency?: string;
  currentSalary: string;
  expectedSalaryCurrencyDropdown?: string;
  expectedSalaryNumeric: string;
  hasExperience?: boolean;
  preferredName?: string;
}

export interface IProfileHubspot {
  id: number;
  properties: {
    actividad_actual_estado: string | null;
    actividad_actual_id: string | null;
    actividad_actual_nombre: string | null;
    aplicativo_ingreso: string;
    birthday: string | null;
    cargo: string | null;
    city: string;
    ciudad_de_residencia: string;
    country: string;
    createdate: string;
    direccion_residencia: string | null;
    email: string;
    estado_aspirante: string;
    estado_civil: string | null;
    fecha_recepcion_del_ensayo: string | null;
    firstname: string;
    grupo_sanguineo: string | null;
    hs_calculated_phone_number_country_code: string;
    hs_object_id: string;
    hubspot_owner_id: string;
    id_negocio_actual: string | null;
    lastmodifieddate: string;
    lastname: string;
    nivel_educativo: string | null;
    nombre_preferido: string | null;
    numero_identificacion: string | null;
    numero_tarjeta_profesional: string | null;
    phone: string;
    sexo: string | null;
    state: string;
    talla_camiseta: string | null;
    tipo_identificacion: string | null;
    titulo_profesional: string | null;
    vacante: string;
    flagurl: string;
    sortname: string;
    phonecode: string;
  };
}

export interface INoCurrentActivity {
  data: DataResponse;
}

export interface DataResponse {
  id: number;
  stage: number;
  vacant: number;
  action: string;
  tab: string;
  type: string;
}

export interface IGetActivity {
  idStage?: number;
  idVacant?: number;
  email?: string;
}

export interface IGetWaitMessageActivity {
  idActivity?: number;
  idVacant?: number;
  email?: string;
}

export interface IOption {
  value: any;
  label: any;
  iconUrl?: string;
  alphaCode?: string;
}

export interface IUserStatus {
  message: string;
  status: number;
  data: Datum[];
}

export interface Datum {
  id: number;
  idStage: number;
  action: string;
  tab: string;
  type: string;
  icons: IconStatus[];
}

export interface IconStatus {
  id: number;
  name: string;
  urlIcon: string;
  identifier: string;
}
export interface IHelpsOption {
  message: string;
  status: number;
  data: dataOptionsHelp[];
}
export interface IResponseHelpsOption {
  option: string;
  email: string;
  message: string;
  id: number;
}

export interface dataOptionsHelp {
  id: number;
  option: string;
  action: string;
  checked: boolean;
}

export interface IVacantDescription {
  message: string;
  statusCode: number;
  errorCode: string;
  data: dataVacantDescription;
}

export interface IOnboardingResponse {
  onboardingStatus: number;
  helpStatus: number;
  profileStatus: number;
}

export interface dataVacantDescription {
  title: string;
  description: string;
}

export interface ISaveUserBody
  extends Omit<
    ICandidateInformation,
    | 'organizationalInformation'
    | 'processInformation'
    | 'growInformation'
    | 'compensationInformation'
    | 'id'
  > {
  names: string;
  secondName?: string;
  lastname: string;
  secondLastname?: string;
  documentType: string;
  documentNumber: string;
  gender: string;
  birthdate: string;
  countryOfBirth: string;
  departamentOfBirth: string;
  cityOfBirth: string;
  civilStatus: string;
  bloodGroup: string;
  indicative: string;
  phone: string;
  email: string;
  countryOfResidence: string;
  departamentOfResidence: string;
  cityOfResidence: string;
  address: string;
  educationLevel: string;
  professionalTitle: string;
  hasProfessionalCard: string;
  professionalCard: string;
  graduationYear: string;
  semester: string;
  preferredName: string;
  shirtSize: string;
}

export interface IAdmissionDate {
  admissionDate: string;
  admissionHour: string;
}

export interface ISaveDocumentBody {
  file: File;
  folder: string;
}

export interface ISaveDocumentBeneficiaryBody {
  files: File[];
  folder: string;
}

export interface ISaveBeneficiaryBody {
  names: string;
  lastname: string;
  birthdate: string;
  documentType: string;
  documentNumber: string;
  relationshipId: number;
  relationshipName: string;
  email: string;
  listDocument: ISaveFileBeneficiaryBody[];
}
export interface ISendDocumentsBody {
  email: string;
  idVacant: number;
  fullName: string;
}

export interface ISaveFileBeneficiaryBody {
  originalName: string;
  newName: string;
  docType: string | IDocument;
  url: string;
  fileSize: string;
}

export interface File {
  fileBase64: string;
  fileName: string;
}

export interface ISaveDocumentInHiringBody {
  email: string;
  originalName: string;
  newName: string;
  docType?: documentTypes | string;
  url?: string;
  fileSize: string;
  fileKey?: string;
}

export interface ISavedDocuments {
  cedula: ISavedDocument[];
  tarjeta_profesional: ISavedDocument[];
  cert_estudios: ISavedDocument[];
  cert_pension: ISavedDocument[];
  cert_cesantias: ISavedDocument[];
  cert_eps: ISavedDocument[];
  libreta: ISavedDocument[];
  acta_grado: ISavedDocument[];
  cert_bancario: ISavedDocument[];
  beneficiario: ISavedDocument[];
}

interface ISavedDocument {
  originalName: string;
  newName: string;
  url: string;
  fileSize: string;
}

export interface IDeleteSavedDocumentBody {
  email?: string;
  newNameDocument: string;
  documentTypeName: string;
  url?: string;
  fileKey?: string;
}

export interface IDeleteBeneficiaryBody {
  email: string;
  relationshipName: string;
  documentNumber: string;
}
export interface IStatusBody {
  email: string | any;
  qualifierName: string;
}
export interface INewCandidates {
  [key: string]: any;
  email: string;
  fullName: string;
  dateStart: string;
  role: string;
  qualifierName?: string;
  closeDate?: string;
}
export interface IUpdatePersonalInfoHiringBody {
  email: string;
  names: string;
  secondName?: string;
  lastname: string;
  secondLastname?: string;
  birthdate: string;
  gender: string;
  civilStatus: string;
  bloodGroup: string;
  documentType: string;
  documentNumber: string;
  shirtSize: string;
  preferredName: string;
  civilStatusEn: string;
}

export interface IUpdateOrganizationalInfoHiringBody {
  email: string;
  division: string;
  department: string;
  referred: string;
  updateGrowRequest: IUpdateGrowRequest[];
}

interface IUpdateGrowRequest {
  chapter: string;
  specialty: string;
  technology: string;
  technicaLevel: string;
  position: number;
}
export interface IUpdateAcademicInfoHiringBody {
  email: string;
  graduationYear: string;
  hasProfessionalCard: string;
  professionalCard: string;
  professionalTitle: string;
  semester: string;
  cv: string;
  educationalLevel: string;
  institution: string;
  country: string;
  endDate: string;
  startDate: string | null;
  id?: number;
}
export interface IUpdateContactInfoHiringBody {
  email: string;
  countryOfResidence: string;
  departamentOfResidence: string;
  cityOfResidence: string;
  addressType: string;
  address: string;
  complementaryAddresses: string;
  phone: string | number;
  countryOfResidenceISO: string;
  state: string;
  countryOfBirthEn: string;
}
export interface IUpdateCompensationInfoHiringBody {
  email: string;
  contractType: string;
  position: string | number;
  role: string;
  startDate: string;
  contractTypeEn: string;
  contractTypeCountry: string;
  compensationInformation: IcompensationInformationBody | any[];
}
export interface IcompensationInformationBody {
  payrollComponent: string;
  salaryBase: string;
  currency: string;
  position: string;
}

export interface ICandidateInformation {
  address: string;
  addressType: string;
  birthdate: string;
  bloodGroup: string;
  cityOfBirth: string | null;
  cityOfResidence: string;
  civilStatus: string;
  compensationInformation: any[]; // Puedes ajustar el tipo según la estructura real de compensationInformation
  complementaryAddresses: string;
  countryOfBirth: string | null;
  countryOfResidence: string;
  cv: string;
  departamentOfBirth: string | null;
  departamentOfResidence: string;
  documentNumber: string;
  documentType: string;
  educationLevel: string;
  email: string;
  gender: string;
  graduationYear: string;
  greeting: string;
  growInformation: any[]; // Puedes ajustar el tipo según la estructura real de growInformation
  hasProfessionalCard: string;
  id: number;
  indicative: string | null;
  lastname: string;
  names: string;
  organizationalInformation: IOrganizationalInformation;
  phone: string;
  preferredName: string;
  processInformation: IProcessInformation;
  professionalCard: string;
  professionalTitle: string;
  role: string;
  semester: string;
  shirtSize: string;
  secondName?: string;
  secondLastname?: string;
}

export interface IOrganizationalInformation {
  id: number;
  contractType: string;
  contractTypeCountry: string;
  contractTypeEn: string;
  department: string;
  division: string;
  position: string;
  referred: string;
  startDate: string;
  userModel: any | null;
}

export interface IProcessInformation {
  id: number;
  qualifierName: string;
  closeDate: string;
  processStatus: boolean;
  userModel: any | null;
}

export interface IUpdateBankingInformation {
  email: string;
  bankInformation: {
    financialEntity: string;
    accountNumber: string;
    cci: string;
  };
}

export interface ICashFlowBody {
  moneda: string;
  tipoContrato: string;
  basico: number;
  integral: number;
  pv: number;
  institucional: number;
  alimentacion: number;
}

export interface ICancelMeeting {
  idActivity: string;
  email: string;
}

export interface IParameterRequest {
  parameterName: string;
}

export interface IParameterResponse {
  id: string;
  name: string;
  description: string;
  value: string;
}
export enum UserProfileStatus {
  STARTED = 'Started',
  COMPLETED = 'Completed',
}

export interface IGetUserProfileStatus {
  data: {
    state: UserProfileStatus | null;
  };
}

export interface ISetUserProfileStatus {
  email: string;
  status: UserProfileStatus;
}
